import { $ } from "../../../../helpers/dom-selectors.js";
import makeFormRequest from "../../../../helpers/form-request.js";
import ServerResponse from "../../../../helpers/render-server-response.js";
import Request from "../../../../helpers/request.js";
import APP_COMPONENTS from "../components/index.js";
export default {
    execute: async (data) => {
        const { index, id, form, submitBtn } = data;
        const fileURL = APP_COMPONENTS.fileForms.getURL(index);
        if (!fileURL) {
            APP_COMPONENTS.fileError.show('INCOMPLETE', 'Please upload an image before submitting.');
            return;
        }
        const instrumentInputs = $(form, "input[name='instruments']");
        const instruments = [];
        instrumentInputs.forEach(input => {
            instruments.push(input.value.trim());
        });
        const payload = {
            id,
            name: form.fullname.value.trim(),
            image: fileURL,
            country: form.country.value.trim(),
            instruments,
            bio: form.bio.value.trim() || null,
            link: form.link.value.trim() || null,
            orderIndex: index
        };
        const formRequest = makeFormRequest({ form, submitBtn });
        const response = await Request.post('/musicians/update', payload);
        formRequest.afterResponse(false);
        if (response.success) {
            ServerResponse.show({
                resp: response,
                respTitle: 'SUCCESS',
                respText: `Musician updated successfully.`
            });
            APP_COMPONENTS.fileForms.update(index, form, id);
            return;
        }
        ServerResponse.show({
            resp: response,
            respTitle: 'ERROR',
            respText: response.error
        });
    }
};
